import pick from 'lodash.pick';
import pickBy from 'lodash.pickby';

export function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isObjectEmpty(value) {
  if (!isObject(value)) {
    return true;
  }

  return Object.keys(value).length === 0;
}

export function pickDefined(obj, paths) {
  return pick(
    pickBy(obj, (value) => value !== undefined),
    paths
  );
}

export function flattenObject(object = {}) {
  const flattenedObject = {};

  for (const key in object) {
    const value = object[key];

    if (isObject(value)) {
      const nestedObject = flattenObject(value);

      for (const nestedKey in nestedObject) {
        flattenedObject[key + '.' + nestedKey] = nestedObject[nestedKey];
      }
    } else {
      flattenedObject[key] = value;
    }
  }

  return flattenedObject;
}
